'use client';

import { useEffect, useRef } from 'react';
import { useReportWebVitals } from 'next/web-vitals';
import { reportWebVitals } from '@/utils/performance/web-vitals';
import { setupResourceQueueingHelper } from './resource-monitor';

/**
 * Web Vitals Reporter Component
 *
 * Uses Next.js built-in useReportWebVitals hook to track performance metrics.
 *
 * Metrics tracked (Next.js 15):
 * - Core Web Vitals: LCP, FID, INP, CLS, FCP, TTFB
 *
 * Note: Next.js-specific metrics (hydration, route-change-to-render, render)
 * require Next.js 16+ and will be available after upgrade.
 *
 * Metrics are sent to:
 * - Datadog RUM (for monitoring and alerting)
 * - Browser console (with color coding in development)
 * - localStorage (development only, for debugging)
 */
export const WebVitalsReporter = () => {
    const initialized = useRef(false);

    useReportWebVitals((metric) => {
        reportWebVitals(metric);
    });

    // Initialize resource queueing helper (development only)
    // TODO add this only for develop or by setting a cookie
    useEffect(() => {
        if (initialized.current) {
            return () => {};
        }
        initialized.current = true;

        setupResourceQueueingHelper();

        console.log(
            '%c[Web Vitals] ⚡ Monitoring Active',
            'color: #0cce6b; font-weight: bold; font-size: 12px; padding: 4px;'
        );
        console.log('%c[Web Vitals] Tracking: LCP, FID, INP, CLS, FCP, TTFB', 'color: #666; font-size: 11px;');
        console.log(
            '%c[Web Vitals] Note: Next.js-specific metrics require Next.js 16+',
            'color: #999; font-size: 10px; font-style: italic;'
        );
    }, []);

    return null;
};
